import { Modifier } from '../modifier';
import { actionHistory } from '../../../store';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Rested extends Modifier {
  static readonly baseTitle = 'Rested';
  static readonly baseText = 'Increase max health by the number of stacks.';
  static readonly baseIcon = 'rested';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Rested.baseTitle;
  text = Rested.baseText;
  icon = Rested.baseIcon;
  tags: Array<ModifierTags> = [...Rested.baseTags];
  priority = Rested.basePriority;

  init(params?: ModifierParams) {
    super.init(params);
    this.owner.healthMax += this.stacks;
    this.owner.healthCurrent += this.stacks;
  }

  update(stacks: number) {
    super.update(stacks);

    this.owner.healthMax += stacks;
    this.owner.healthCurrent += stacks;
  }

  removeStacks(stacks: number): void {
    this.owner.healthMax -= stacks;

    super.removeStacks(stacks);
  }

  remove() {
    if (this.stacks > 0) {
      this.owner.healthMax -= this.stacks;

      this.stacks = 0;
    }
    super.remove();
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Rested, Rested);
